module.exports = __webpack_public_path__ + "static/media/gallery_02_t.edb23c4b.jpg";